import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import Component from '../components/timeslot'
import actions from '../actions/timeslot'
import depositActions from '../actions/deposit'

class Container extends React.Component {

  constructor(props) {
    super(props)
    props.getUnavailableDates()
  }

  render() {
    return <Component {...this.props}/>
  }

  static propTypes = {
    getUnavailableDates: PropTypes.func.isRequired,
  }
}

const mapStateToProps = state => {
  const data = state.ui.deposit.timeslot
  const startData = state.ui.deposit.start
  return {
    dateSelected: data.get('date'),
    unavailableDates: data.get('unavailableDates').toArray(),
    timeslotSelected: data.get('timeslot'),
    timeslots: data.get('timeslots').toArray(),
    isFetchingDates: data.get('isFetchingDates') || state.ui.deposit.start.get('isFetching'),
    isFetchingTimeslots: data.get('isFetchingTimeslots'),
    isButtonLoading: data.get('isModifying'),
    isButtonDisabled: data.get('isFetchingDates') || state.ui.deposit.start.get('isFetching') || data.get('isFetchingTimeslots'),
    error: data.get('error'),
    address: startData.getIn(['transaction', 'ID']) ? startData.getIn(['transaction', 'ClientAddress']).Address : "",
  }
}

const mapDispatchToProps = dispatch => {
  return {
    selectDate: date => dispatch(actions.selectDate(date)),
    selectTimeslot: timeslot => dispatch(actions.selectTimeslot(timeslot)),
    getUnavailableDates: () => dispatch(actions.getUnavailableDates()),
    getTimeslots: () => dispatch(actions.getTimeslots()),
    setStep: step => dispatch(depositActions.setStep(step)),
    modifyTransaction: () => dispatch(actions.modifyTransaction()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/deposit/containers/timeslot.js